import * as React from 'react'

import { Container, ContentContainer, IconContainer } from './Bullet.styles'

interface IProps {
  children: React.ReactNode
  icon: React.ReactNode
}

export default function Bullet(props: IProps) {
  const { children, icon } = props

  return (
    <Container>
      <IconContainer>{icon}</IconContainer>
      <ContentContainer>{children}</ContentContainer>
    </Container>
  )
}
